import moment from 'moment';

export const formatNumber = (num: number): string => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const jsonParse = <T>(jsonStringify: string): T => {
    return JSON.parse(jsonStringify);
}

export const formatRut = (rut: string): string => {
    const cleanedRut = rut.replace(/[.-]/g, '');

    const prefix = cleanedRut.slice(0, -1);
    const suffix = cleanedRut.slice(-1);

    return `${prefix}-${suffix}`;
}

export const validarRut = (rutTemp: string): boolean => {
    let valor: any = rutTemp.replace(/\./g, '');
    valor = valor.replace('-', '');

    const part1 = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();

    let suma = 0;
    let multiplo = 2;

    for (let i = 1; i <= part1.length; i += 1) {
        const index = multiplo * parseInt(valor.charAt(part1.length - i), 10);
        suma += index;
        if (multiplo < 7) {
            multiplo += 1;
        } else {
            multiplo = 2;
        }
    }

    const dvEsperado = 11 - (suma % 11);

    if (dv === 'K') {
        dv = '10';
    } else if (dv === '0') {
        dv = '11';
    }

    return String(dvEsperado) === dv;
};


export const generateAvatar = (firstName: string, lastName: string = '', bgColor: string = ''): string => {
    const canvasColors = [
        { bg: '#4880FF', text: '#ffffff' }
    ];
    const canvasOpcion = Math.floor(Math.random() * 1);
    const canvasImage = document.createElement('canvas');
    canvasImage.width = 400;
    canvasImage.height = 400;
    const ctx = canvasImage.getContext('2d');

    if (!ctx) {
        throw new Error("Could not get 2D context");
    }

    ctx.globalAlpha = 1;
    ctx.fillStyle = bgColor !== '' ? bgColor : canvasColors[canvasOpcion].bg;
    ctx.fillRect(0, 0, canvasImage.width, canvasImage.height);
    ctx.save();
    ctx.font = '200px Arial';
    ctx.textAlign = 'center';
    ctx.fillStyle = canvasColors[canvasOpcion].text;

    const initials = lastName
        ? (firstName.charAt(0) + lastName.charAt(0)).toUpperCase()
        : (firstName.charAt(0) + (firstName.charAt(1) || '')).toUpperCase();

    ctx.fillText(initials, canvasImage.width / 2, 270);

    return canvasImage.toDataURL();
}

export const calculateDose = (num1: any, num2: any) => {
    const sanitizedNum1 = typeof num1 === 'string' ? num1.replace(',', '.') : num1;
    const sanitizedNum2 = typeof num2 === 'string' ? num2.replace(',', '.') : num2;
    const TEMP = Number(sanitizedNum1) * Number(sanitizedNum2);
    return parseFloat(TEMP.toFixed(2));
}

export const generateRandomOrder = () => Math.floor(100000 + Math.random() * 900000).toString();

export const calculateTypeOptions = [
    { label: 'Dosis fija', value: 1 },
    { label: 'Superficie corporal', value: 2 },
    { label: 'Dosis AUC', value: 3 },
];

export const calculateAUC = ( auc: any , gfr: any ) => {
    if (auc === null || auc === undefined || auc === '' || gfr === null || gfr === undefined || gfr === '') return 0;
    const sanitizedAUC = typeof auc === 'string' ? auc.replace(',', '.') : auc;
    const sanitizedGFR = typeof gfr === 'string' ? gfr.replace(',', '.') : gfr;
    if (isNaN(Number(sanitizedAUC)) || isNaN(Number(sanitizedGFR))) return 0;
    const TEMP = Number(sanitizedAUC) * ( Number(sanitizedGFR) + 25 );
    return parseFloat(TEMP.toFixed(1));
}

export const truncateString = (text: string, maxLength: number = 350): string => {
    if (text.length <= maxLength) {
        return text;
    }
    return text.slice(0, maxLength) + '...';
}


export const formatTime = ( timeMinutes: number ) => {
    const hours = Math.floor(timeMinutes / 60);
    const minutes = timeMinutes % 60;
    let result = '';
    if (hours > 0) {
        result += `${hours} ${hours === 1 ? 'hora' : 'horas'}`;
    }
    if (minutes > 0) {
        result += hours > 0 ? ` y ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}` : `${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
    }
    return result || '0 minutos';
}

export const adjustStartAndEndDate = (startDate: Date, endDate: Date) => {
    const adjustedStartDate = new Date(startDate);
    adjustedStartDate.setUTCHours(0, 0, 0, 0);
    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setUTCHours(23, 59, 59, 999);
    return { adjustedStartDate, adjustedEndDate };
};

export const generateRandomPerson = () => {
    const firstNames = ["CARLOS", "ANA", "LUIS", "MARIA", "JUAN", "SOFIA", "PEDRO", "LUCIA"];
    const lastNames = ["GONZALEZ", "RODRIGUEZ", "PEREZ", "FERNANDEZ", "GARCIA", "LOPEZ", "MARTINEZ", "SANCHEZ"];

    const randomFirstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const randomLastNameFather = lastNames[Math.floor(Math.random() * lastNames.length)];
    const randomLastNameMother = lastNames[Math.floor(Math.random() * lastNames.length)];
    const fullName = `${randomFirstName} ${randomLastNameFather} ${randomLastNameMother}`;

    const generateValidRut = () => {
        const base = Math.floor(Math.random() * 10000000) + 1000000;
        const dv = calculateRutDv(base);
        return `${base}-${dv}`;
    };
    const calculateRutDv = (rut: any) => {
        let sum = 0;
        let multiplier = 2;
        for (let i = String(rut).length - 1; i >= 0; i--) {
            sum += multiplier * parseInt(String(rut)[i]);
            multiplier = multiplier < 7 ? multiplier + 1 : 2;
        }
        const remainder = 11 - (sum % 11);
        if (remainder === 11) return '0';
        if (remainder === 10) return 'K';
        return String(remainder);
    };
    const rut = generateValidRut();
    return {
        lastNameFather: randomLastNameFather,
        lastNameMother: randomLastNameMother,
        firstName: randomFirstName,
        fullName: fullName,
        rut: rut
    };
};

export const calculateTimeByHour = (totalHours: number) => {
    if (typeof totalHours !== 'number' || totalHours < 0) {
        throw new Error('El valor debe ser un número mayor o igual a 0');
    }

    const days = Math.floor(totalHours / 24);
    const hours = Math.floor(totalHours % 24);
    const minutes = Math.round((totalHours * 60) % 60);

    const daysText = days === 1 ? `${days} día` : `${days} días`;
    const hoursText = hours === 1 ? `${hours} hora` : `${hours} horas`;
    const minutesText = minutes === 1 ? `${minutes} minuto` : `${minutes} minutos`;

    let result = [];
    if (days > 0) result.push(daysText);
    if (hours > 0) result.push(hoursText);
    if (minutes > 0) result.push(minutesText);
    
    if (result.length === 0) return '0 minutos';
    return result.join(' ');
};


export const getDateFormat = (dateString: string) => {
    const isoFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    const simpleFormatRegex = /^\d{4}-\d{2}-\d{2}$/;

    if (simpleFormatRegex.test(dateString)) {
        const [year, month, day] = dateString.split('-').map(Number);
        const utcDate = new Date(Date.UTC(year, month - 1, day));
        return utcDate.toISOString();
    } else if (isoFormatRegex.test(dateString)) {
        return dateString;
    } else {
        return undefined;
    }
}

export const calculateBottle = ( dosis: any , presentacion: any ) => {
    const presentation = Number( presentacion )
    const dose = Number( dosis )
    if (presentation === 0) {
        throw new Error("El denominador no puede ser cero.");
    }
    const result = dose / presentation;
    return Math.ceil(result);
}

export const calculateVolumeDrug = ( dose: number , concentration: number ) => {
    const numConcentration = Number(concentration);
    if (isNaN(numConcentration) || numConcentration === 0) {
        return 0;
    }
    return Number((dose / numConcentration).toFixed(4));
}

export const calculateExpires = ( ob: any ) => {
    const postElaborationDate = ob.postElaborationDate
    const stabilityHours = ob.medications.laboratorySelected.stability;
    return moment.utc(postElaborationDate).add(stabilityHours, 'hours').format("DD/MM/YYYY - HH:mm");
}

export const getNameCondition = ( number: any ) => {
    const name = number === 1 ? 'NO REFRIGERAR' : 'REFRIGERAR'
    return name
}

export const getLiberationPrint = ( data: any , user: any ) => {
    const getName = () => {
        const { lastNameFather, lastNameMother, name } = data.patient;
        const fullName = `${lastNameFather} ${lastNameMother}, ${name}`;
        return fullName.length > 31 ? fullName.slice(0, 31) : fullName;
    };

    const utcDate = data.liberationDate;
    return `^XA
            ^PW440
            ^LL360
            ^CI28
            ^CF0,28,25
            ^FO150,30^A0N,45,40^FDLIBERADO^FS
            ^FO15,100^FDPACIENTE: ${ getName() }^FS
            ^FO15,155^FDR.M.: ${data?.RM || ''}^FS
            ^FO15,210^FDLIBERÓ: ${ user?.given_name } ${ user?.family_name }^FS
            ^FO15,265^FDFECHA DE LIBERACIÓN: ${moment.utc( utcDate ).format('DD/MM/YYYY')}^FS
            ^FO15,320^FDHORA DE LIBERACIÓN: ${moment.utc( utcDate ).format('HH:mm')}^FS
            ^XZ`
}

export const getElaborationPrint = ( data: any , DT: any  , QF: any, address: any) => {

    const getName = () => {
        const { lastNameFather, lastNameMother, name } = data.patient;
        const fullName = `${lastNameFather} ${lastNameMother}, ${name}`;
        return fullName.length > 31 ? fullName.slice(0, 31) : fullName;
    };

    return  `^XA
            ^PW800
            ^LL480
            ^CI28
            ^CF0,25,22
            ^FO50,30^FDRF XIII 02/20: 3B,3C,3D^FS
            ^FO340,30^FD${ address }^FS
            ^FO50,62^FDTherapía IV - DT ${ DT.name || '' }^FS
            ^FO167,93^FDQF ${ QF.name || '' }^FS
            ^FO50,120^GB700,2,2^FS
            ^FO50,205^GB700,2,2^FS
            ^FO49,121^GB1,85,2^FS
            ^FO750,121^GB1,85,2^FS
            ^FO60,135^FDRUT: ${data.patient.rut !== '' ? data.patient.rut : data.patient.passport !== '' ? data.patient.passport: data.patient.sheet }^FS
            ^FO60,165^A0N,35,30^FD${ getName() }^FS
            ^FO50,230^FDFecha: ${ moment.utc( data.medications.administrationDate ).format('DD/MM/YYYY') }^FS
            ^FO550,230^FDCiclo Actual: ${ data.medications.cycle }^FS
            ^FO50,270^FDServicio: ${data.treatment.service}^FS
            ^FO50,310^FDInstitución: ${data.organizationName}^FS
            ^FO50,350^FDMédico: ${data.doctor.firstName} ${data.doctor.lastNameFather} ${data.doctor.lastNameMother}^FS
            ^FO220,390^A0N,35,30^FDTRATAMIENTO QUIMIOTERÁPICO^FS
            ^FO50,440^FDEsquema: ${data.treatment.treatmentProtocol}^FS
            ^XZ
            ^XA
            ^PW800
            ^LL480
            ^CI28
            ^CF0,25,22
            ^FO50,30^FDRF XIII 02/20: 3B,3C,3D^FS
            ^FO340,30^FD${ address }^FS
            ^FO50,62^FDTherapía IV - DT ${ DT.name || '' }^FS
            ^FO167,93^FDQF ${ QF.name || '' }^FS
            ^FO450,55
            ^BY1,1,50
            ^BCR,25
            ^BCN,40,N,N,N
            ^FD${data._id}^FS
            ^FO451,100^A0N,20,27^FD${data._id}^FS
            ^FO50,120^GB700,2,2^FS
            ^FO50,180^GB700,2,2^FS
            ^FO49,121^GB1,60,2^FS
            ^FO750,121^GB1,60,2^FS
            ^FO60,138^A0N,35,30^FD${ getName() }^FS
            ^FO50,196^FDRUT: ${data.patient.rut !== '' ? data.patient.rut : data.patient.passport !== '' ? data.patient.passport: data.patient.sheet }^FS
            ^FO450,196^FDEsquema: ${data.treatment.treatmentProtocol}^FS
            ^FO50,232^FD${ moment.utc( data.medications.administrationDate ).format('DD/MM/YYYY') }^FS
            ^FO260,232^FDDía: ${ data.medications.drugDay }^FS
            ^FO450,232^FDLote n°: ${data.medications.batch1}${data.medications.batch2?.trim() !== '' ? ` - ${data.medications.batch2 || ''}` : ''}^FS
            ^FO50,266^GB700,2,2^FS
            ^FO50,338^GB700,2,2^FS
            ^FO49,267^GB1,72,2^FS
            ^FO750,267^GB1,72,2^FS
            ^FO60,278^FD${ data.medications.drugIntName } ${ data.medications.dose } ${ data.medications.presentationSelected.drugPreUnit }^FS
            ^FO400,278^FD${ data.medications.laboratorySelected.name }^FS
            ^FO60,306^FD${ data.medications.solutionName } ${ calculateVolumen( data ) } ml^FS
            ^FO400,306^FD${ data.medications.infusionSetName }^FS
            ^FO50,354^FDVol.Total = ${ Number( ( calculateVolumen( data ) + calculateVolumeDrug( data.medications.dose , data.medications.presentationSelected?.drugConcentration ) ).toFixed(4) ) } ml^FS
            ^FO450,354^FDTiempo de Administración:^FS
            ^FO450,384^FD${formatTime( data.medications.administrationTime )}^FS
            ^FO50,384^FDR.M. ${data?.RM || ''}^FS
            ^FO50,415^FD${ data.medications.administrationRouteName }^FS
            ^FO50,450^FDCITOSTÁTICO - Proteger Luz.^FS
            ^FO450,450^FDCaduca: ${ calculateExpires( data ) }^FS
            ^FO6,130^A0B,30,30^FD${ getNameCondition( Number( data.medications.presentationSelected.drugStorageConditions ) ) }^FS
            ^FO38,0^GB1,480,2^FS
            ^XZ
            ^XA
            ^PW800
            ^LL480
            ^CI28
            ^CF0,25,22
            ^FO50,30^FDRF XIII 02/20: 3B,3C,3D^FS
            ^FO340,30^FD${ address }^FS
            ^FO50,62^FDTherapía IV - DT ${ DT.name || '' }^FS
            ^FO167,93^FDQF ${ QF.name || '' }^FS
            ^FO450,55
            ^BY1,1,50
            ^BCR,25
            ^BCN,40,N,N,N
            ^FD${data._id}^FS
            ^FO451,100^A0N,20,27^FD${data._id}^FS
            ^FO50,120^GB700,2,2^FS
            ^FO50,180^GB700,2,2^FS
            ^FO49,121^GB1,60,2^FS
            ^FO750,121^GB1,60,2^FS
            ^FO60,138^A0N,35,30^FD${ getName() }^FS
            ^FO50,196^FDRUT: ${data.patient.rut !== '' ? data.patient.rut : data.patient.passport !== '' ? data.patient.passport: data.patient.sheet }^FS
            ^FO450,196^FDEsquema: ${data.treatment.treatmentProtocol}^FS
            ^FO50,232^FD${ moment.utc( data.medications.administrationDate ).format('DD/MM/YYYY') }^FS
            ^FO260,232^FDDía: ${ data.medications.drugDay }^FS
            ^FO450,232^FDLote n°: ${data.medications.batch1}${data.medications.batch2?.trim() !== '' ? ` - ${data.medications.batch2 || ''}` : ''}^FS
            ^FO50,266^GB700,2,2^FS
            ^FO50,338^GB700,2,2^FS
            ^FO49,267^GB1,72,2^FS
            ^FO750,267^GB1,72,2^FS
            ^FO60,278^FD${ data.medications.drugIntName } ${ data.medications.dose } ${ data.medications.presentationSelected.drugPreUnit }^FS
            ^FO400,278^FD${ data.medications.laboratorySelected.name }^FS
            ^FO60,306^FD${ data.medications.solutionName } ${ calculateVolumen( data ) } ml^FS
            ^FO400,306^FD${ data.medications.infusionSetName }^FS
            ^FO50,354^FDVol.Total = ${ Number( ( calculateVolumen( data ) + calculateVolumeDrug( data.medications.dose , data.medications.presentationSelected?.drugConcentration ) ).toFixed(4) ) } ml^FS
            ^FO450,354^FDTiempo de Administración:^FS
            ^FO450,384^FD${formatTime( data.medications.administrationTime )}^FS
            ^FO50,384^FDR.M. ${data?.RM || ''}^FS
            ^FO50,415^FD${ data.medications.administrationRouteName }^FS
            ^FO50,450^FDCITOSTÁTICO - Proteger Luz.^FS
            ^FO450,450^FDCaduca: ${ calculateExpires( data ) }^FS
            ^FO6,130^A0B,30,30^FD${ getNameCondition( Number( data.medications.presentationSelected.drugStorageConditions ) ) }^FS
            ^FO38,0^GB1,480,2^FS
            ^XZ`
}

export const getTodayDateISO = () => {
    const today = new Date();
    const utcDate = new Date(Date.UTC(
        today.getFullYear(), 
        today.getMonth(), 
        today.getDate(), 
        today.getHours(), 
        today.getMinutes(), 
        today.getSeconds(), 
        today.getMilliseconds()
    )).toISOString();
    return utcDate;
}

export const calculateVolumen = (item: any) => {
    if ( item.medications.addOrExtractSelected ) {
        if ( item.medications.addOrExtractSelected.name === 'Adicionar' ) {
            return Number((Number( item.medications.solutionVolume ) + Number( item.medications.addOrExtractSelected.value )).toFixed(4))
        } else {
            return Number((Number(item.medications.solutionVolume) - Number(item.medications.addOrExtractSelected.value)).toFixed(4))
        }
    } else {
        return Number( item.medications.solutionVolume )
    }
}


export const getListRason = () => {
    return [
        {
            id: 1,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Dosis de droga incorrecta',
            classification: 'Dosis incorrecta (Droga/componente)'
        },
        {
            id: 2,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Tipo de droga incorrecto',
            classification: 'Tipo de Droga/ Componente incorrecto'
        },
        {
            id: 3,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Volumen de suero erroneo',
            classification: 'Volumen de vehículo incorrecto'
        },
        {
            id: 4,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Tipo de suero erroneo',
            classification: 'Tipo de Vehículo incorrecto'
        },
        {
            id: 5,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Volumen menor en jeringa',
            classification: 'Volumen de droga incorrecto en jeringa (mayor o menor al requerido).'
        },
        {
            id: 6,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Volumen mayor en jeringa',
            classification: 'Volumen de droga incorrecto en jeringa (mayor o menor al requerido).'
        },
        {
            id: 7,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Partícula en Vehículo',
            classification: 'Partícula: en insumo (set de infusión - infusor -filtro -bolsa EVA - Bolsa Freeflex'
        },
        {
            id: 8,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Partícula en Vehículo',
            classification: 'Partícula: en insumo (set de infusión - infusor -filtro -bolsa EVA - Bolsa Freeflex'
        },
        {
            id: 9,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Partícula al interior del preparado',
            classification: 'Partícula: al interior del preparado'
        },
        {
            id: 10,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Gotas en preparado',
            classification: 'Gotas en preparados'
        },
        {
            id: 11,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Error en registros de hoja de producción',
            classification: 'Registros:  incorrectos'
        },
        {
            id: 12,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Registros incompletos en hoja de producción',
            classification: 'Registros: incompletos en la Hoja de Producción'
        },
        {
            id: 13,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Presencia burbujas en jeringa',
            classification: 'Burbujas (Mix Check Report/ Set de infusion o jeringa)'
        },
        {
            id: 14,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Presencia burbujas en jeringa',
            classification: 'Burbujas (Mix Check Report/ Set de infusion o jeringa)'
        },
        {
            id: 15,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Presencia burbujas en set de infusión ',
            classification: 'Burbujas (Mix Check Report/ Set de infusion o jeringa)'
        },
        {
            id: 16,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Presencia burbujas en set de infusión ',
            classification: 'Burbujas (Mix Check Report/ Set de infusion o jeringa)'
        },
        {
            id: 17,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Preparado Filtrado a nivel de suero',
            classification: 'Filtración'
        },
        {
            id: 18,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Set de infusión con clamp y/o roller abierto',
            classification: 'Set de infusión: Clamp/Roller abierto set de infusión'
        },
        {
            id: 19,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Set de infusión con clamp y/o roller abierto',
            classification: 'Set de infusión: Clamp/Roller abierto set de infusión'
        },
        {
            id: 20,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Set de infusión filtrado',
            classification: 'Filtración'
        },
        {
            id: 21,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Preparado con set de infusión conectado sin solicitud',
            classification: 'Set de infusión: Preparado con set de infusión conectado sin solicitud'
        },
        {
            id: 22,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Set de infusión conectado no corresponde',
            classification: 'Set de infusión: Set conectado no corresponde (Modelo)'
        },
        {
            id: 23,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Presencia de partícula en set de infusión',
            classification: 'Partícula: en insumo (set de infusión - infusor -filtro -bolsa EVA - Bolsa Freeflex'
        },
        {
            id: 24,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Presencia de partícula en set de infusión',
            classification: 'Partícula: en insumo (set de infusión - infusor -filtro -bolsa EVA - Bolsa Freeflex'
        },
        {
            id: 25,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Registros manual incorrecto',
            classification: 'Registro manual: dosis, droga y/o volumen de suero en caso de extracción'
        },
        {
            id: 26,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Registros manual incorrecto',
            classification: 'Registro manual: dosis, droga y/o volumen de suero en caso de extracción'
        },
        {
            id: 27,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Ausencia de firma de adición de droga',
            classification: 'Registros: Ausencia firma en adición manual de droga/componente'
        },
        {
            id: 28,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Volumen mayor en jeringa',
            classification: 'Volumen de droga incorrecto en jeringa (mayor o menor al requerido).'
        },
        {
            id: 29,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Ausencia de tapa en set de infusión',
            classification: 'Set de infusión: Ausencia de tapa azul en set de infusión'
        },
        {
            id: 30,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Ausencia de set de infusión conectado',
            classification: 'Set de infusión: No se conecta set de infusión.'
        },
        {
            id: 31,
            action: 'Reacondicionar',
            area: 'Producción',
            observation: 'Otros',
            classification: 'Otros'
        },
        {
            id: 32,
            action: 'Rechazar',
            area: 'Producción',
            observation: 'Otros',
            classification: 'Otros'
        },
        {
            id: 33,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Dosis de droga incorrecta',
            classification: 'Dosis incorrecta (Droga/componente)'
        },
        {
            id: 34,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Tipo de droga incorrecto',
            classification: 'Tipo de Droga/ Componente incorrecto'
        },
        {
            id: 35,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Volumen de suero erroneo',
            classification: 'Volumen de vehículo incorrecto'
        },
        {
            id: 36,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Tipo de suero erroneo',
            classification: 'Tipo de Vehículo incorrecto'
        },
        {
            id: 37,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en datos del paciente (nombre, apellido, RUT)',
            classification: 'Registros: Error información del paciente en Hoja de Producción (Nombre - Servicio - Medico - etc)'
        },
        {
            id: 38,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Error en dosis de componente',
            classification: 'Dosis incorrecta (Droga/componente)'
        },
        {
            id: 39,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en fecha de administración',
            classification: 'Hoja de producción: fecha de administración no corresponde a la indicada en la receta'
        },
        {
            id: 40,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Error en fecha de administración',
            classification: 'Hoja de producción: fecha de administración no corresponde a la indicada en la receta'
        },
        {
            id: 41,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en RM',
            classification: 'Correlativo etiquetas no corresponde'
        },
        {
            id: 42,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en servicio',
            classification: 'Registros: Error información del paciente en Hoja de Producción (Nombre - Servicio - Medico - etc)'
        },
        {
            id: 43,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en tiempo de administración',
            classification: 'Etiqueta: error en información'
        },
        {
            id: 44,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en fecha de caducidad',
            classification: 'Etiqueta: error fecha de caducidad/ hora'
        },
        {
            id: 45,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en datos de Etiqueta',
            classification: 'Etiqueta: error en información'
        },
        {
            id: 46,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Registros incompletos en hoja de producción',
            classification: 'Registros: incompletos en la Hoja de Producción'
        },
        {
            id: 47,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Requerimiento no conforme (set de infusión)',
            classification: 'Set de infusión: indicado en hoja de producción no corresponde'
        },
        {
            id: 48,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Rotulos con igual correlativo',
            classification: 'Correlativo etiquetas no corresponde'
        },
        {
            id: 49,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Cambios registrados en receta sin firma de QF',
            classification: 'Registros: Ausencia autorización de cambios (receta/HP)'
        },
        {
            id: 50,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Set de infusión erróneo',
            classification: 'Set de infusión: Set conectado no corresponde (Modelo)'
        },
        {
            id: 51,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Set de infusión erróneo no conectado',
            classification: 'Set de infusión: Error en set de infusión no conectado (Modelo)'
        },
        {
            id: 52,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Hoja de producción no indica set de infusión (conectado)',
            classification: 'Set de infusión: No se conecta set de infusión.'
        },
        {
            id: 53,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Rotulo ilegible y/o con información cortada',
            classification: 'Etiqueta: ilegible'
        },
        {
            id: 54,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Registros incorrectos en hoja de producción',
            classification: 'Registros: incompletos en la Hoja de Producción'
        },
        {
            id: 55,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Error en registros de hoja de producción',
            classification: 'Registros:  incorrectos'
        },
        {
            id: 56,
            action: 'Reacondicionar',
            area: 'Autorización',
            observation: 'Otros',
            classification: 'Otros'
        },
        {
            id: 57,
            action: 'Rechazar',
            area: 'Autorización',
            observation: 'Otros',
            classification: 'Otros'
        },
        {
            id: 58,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Partícula en bolsas de cierre dentado',
            classification: 'Partícula: entre bolsas de cierre dentado'
        },
        {
            id: 59,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Partícula en set de infusión sin conectar',
            classification: 'Partícula: en insumo (set de infusión - infusor -filtro -bolsa EVA - Bolsa Freeflex'
        },
        {
            id: 60,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Ausencia bolsa fotoprotectora',
            classification: 'Ausencia o error en  bolsa fotoprotectora'
        },
        {
            id: 61,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Ausencia de bolsa de cierre dentado',
            classification: 'Ausencia bolsa cierre dentado'
        },
        {
            id: 62,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Ausencia de rótulo extra',
            classification: 'Etiqueta: Ausencia etiqueta bolsa fotoprotectora o adicional'
        },
        {
            id: 63,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Ausencia de set de infusión sin conectar',
            classification: 'Set de infusión: Ausencia set de infusión (sin conectar).'
        },
        {
            id: 64,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Error en set de infusión no conectado',
            classification: 'Set de infusión: Error en set de infusión (sin conectar).'
        },
        {
            id: 65,
            action: 'Rechazar',
            area: 'Etiquetado',
            observation: 'Ausencia de tapa roja (puerto de inyección)',
            classification: 'Ausencia de tapa roja en puerto de inyección'
        },
        {
            id: 66,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Ausencia de tapa roja (puerto de inyección)',
            classification: 'Ausencia de tapa roja en puerto de inyección'
        },
        {
            id: 67,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Bolsa de cierre dentado rota',
            classification: 'Bolsa cierre dentado dañada'
        },
        {
            id: 68,
            action: 'Rechazar',
            area: 'Etiquetado',
            observation: 'Etiquetado cruzado',
            classification: 'Etiqueta: Etiquetado cruzado'
        },
        {
            id: 69,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Etiquetado cruzado',
            classification: 'Etiqueta: Etiquetado cruzado'
        },
        {
            id: 70,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Gotas en bolsa de cierre dentado',
            classification: 'Gotas en preparados'
        },
        {
            id: 71,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Set de infusión doblado',
            classification: 'Otros'
        },
        {
            id: 72,
            action: 'Rechazar',
            area: 'Etiquetado',
            observation: 'Set de infusión doblado',
            classification: 'Otros'
        },
        {
            id: 73,
            action: 'Rechazar',
            area: 'Etiquetado',
            observation: 'Preparado oncológico sin rótulo adherido',
            classification: 'Etiqueta: Ausencia etiqueta envase primario'
        },
        {
            id: 74,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Preparado oncológico sin rótulo adherido',
            classification: 'Etiqueta: Ausencia etiqueta envase primario'
        },
        {
            id: 75,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Registros incorrectos en hoja de producción',
            classification: 'Registros: incompletos en la Hoja de Producción'
        },
        {
            id: 76,
            action: 'Reacondicionar ',
            area: 'Etiquetado',
            observation: 'Error en registros de hoja de producción',
            classification: 'Registros: incorrectos'
        },
        {
            id: 77,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Cabello o particula extraña en bolsa de cierre dentado',
            classification: 'Partícula: Presencia de partícula extraña (cabello/ insecto/vidrio)'
        },
        {
            id: 78,
            action: 'Reacondicionar',
            area: 'Etiquetado',
            observation: 'Otros',
            classification: 'Otros'
        },
        {
            id: 79,
            action: 'Rechazar',
            area: 'Etiquetado',
            observation: 'Otros',
            classification: 'Otros'
        },
        {
            id: 100 ,
            action: "Devolver",
            area:"Bodega",
            observation:"Error en solicitud (Laboratorio - Presentación - Cantidad).",
            classification: ""
        },
        {
            id: 101 ,
            action: "Devolver",
            area:"Bodega",
            observation:"Stock insuficiente.",
            classification: ""
        },
        {
            id: 102 ,
            action: "Devolver",
            area:"Bodega",
            observation:"Error en origen de droga.",
            classification: ""
        },
        {
            id: 103 ,
            action: "Devolver",
            area:"Picking",
            observation:"Falta droga.",
            classification: ""
        },
        {
            id: 104 ,
            action: "Devolver",
            area:"Picking",
            observation:"Presentación de frascos erronea.",
            classification: ""
        },
        {
            id: 105 ,
            action: "Devolver",
            area:"Picking",
            observation:"Laboratorio de droga no corresponde.",
            classification: ""
        },
        {
            id: 106 ,
            action: "Devolver",
            area:"Picking",
            observation:"Faltante de insumos.",
            classification: ""
        },
        {
            id: 107 ,
            action: "Devolver",
            area:"Picking",
            observation:"Deterioro de droga.",
            classification: ""
        },
        {
            id: 108 ,
            action: "Devolver",
            area:"Picking",
            observation:"Deterioro de insumos.",
            classification: ""
        },
        {
            id: 109 ,
            action: "Devolver",
            area:"Picking",
            observation:"Suspende paciente.",
            classification: ""
        },
        {
            id: 110 ,
            action: "Devolver",
            area:"Picking",
            observation:"Error de coordinación.",
            classification: ""
        },
        {
            id: 111 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Falta droga.",
            classification: ""
        },
        {
            id: 112 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Presentación de frascos erronea.",
            classification: ""
        },
        {
            id: 113 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Laboratorio de droga no corresponde.",
            classification: ""
        },
        {
            id: 114 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Faltante de insumos.",
            classification: ""
        },
        {
            id: 115 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Deterioro de droga.",
            classification: ""
        },
        {
            id: 116 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Deterioro de insumos.",
            classification: ""
        },
        {
            id: 117 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Suspende paciente.",
            classification: ""
        },
        {
            id: 118 ,
            action: "Devolver",
            area:"Sanitización I",
            observation:"Error de coordinación.",
            classification: ""
        },
        {
            id: 119 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Falta droga.",
            classification: ""
        },
        {
            id: 120 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Presentación de frascos erronea.",
            classification: ""
        },
        {
            id: 121 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Laboratorio de droga no corresponde.",
            classification: ""
        },
        {
            id: 122 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Faltante de insumos.",
            classification: ""
        },
        {
            id: 123 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Deterioro de droga.",
            classification: ""
        },
        {
            id: 124 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Deterioro de insumos.",
            classification: ""
        },
        {
            id: 125 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Suspende paciente.",
            classification: ""
        },
        {
            id: 126 ,
            action: "Devolver",
            area:"Sanitización II",
            observation:"Error de coordinación.",
            classification: ""
        },
        {
            id: 127 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Falta droga.",
            classification: ""
        },
        {
            id: 128 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Presentación de frascos erronea.",
            classification: ""
        },
        {
            id: 129 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Laboratorio de droga no corresponde.",
            classification: ""
        },
        {
            id: 130 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Faltante de insumos.",
            classification: ""
        },
        {
            id: 131 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Deterioro de droga.",
            classification: ""
        },
        {
            id: 132 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Deterioro de insumos.",
            classification: ""
        },
        {
            id: 133 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Suspende paciente.",
            classification: ""
        },
        {
            id: 134 ,
            action: "Devolver",
            area:"Pre-elaboración",
            observation:"Error de coordinación.",
            classification: ""
        },
        {
            id: 135 ,
            action: "Devolver",
            area:"Post-elaboración",
            observation:"Razón Post-elaboración 1",
            classification: ""
        },
        {
            id: 136 ,
            action: "Devolver",
            area:"Post-elaboración",
            observation:"Razón Post-elaboración 2",
            classification: ""
        },
        {
            id: 137 ,
            action: "Devolver",
            area:"Post-elaboración",
            observation:"Razón Post-elaboración 3",
            classification: ""
        },
        {
            id: 138 ,
            action: "Devolver",
            area:"Etiquetado",
            observation:"Razón Etiquetado 1",
            classification: ""
        },
        {
            id: 139 ,
            action: "Devolver",
            area:"Etiquetado",
            observation:"Razón Etiquetado 2",
            classification: ""
        },
        {
            id: 140 ,
            action: "Devolver",
            area:"Etiquetado",
            observation:"Razón Etiquetado 3",
            classification: ""
        },

    ]
}
